export default {
  //判断是否为管理员
  isAdmin (state) {
    return Boolean(state.userLoginMessage.socketType === 'admin');
  },
  //管理员登录信息
  adminInfo (state) {
    return {
      truename: state.userLoginMessage.truename,
      username: state.userLoginMessage.username,
      login_num: state.userLoginMessage.login_num,
      mobile: state.userLoginMessage.mobile
    }
  },
  //待审核信息总数
  totalVerify(state) {
    let total = 0;
    let valueArr = ['comment','storeVerify','homestayActi','hotelActi','ticket'];
    valueArr.forEach(v => total += Number(state.waitVerify[v]))
    return total
  }
}
